export default "__VITE_ASSET__CBWcwxb4__"